import Connector from './api'
import cookie from './cookies'

const oauthcore = {
  install: function (Vue, option) {
    Vue.prototype.$oauthcore = {
      api: new Connector(),
      cookie: cookie
    }
  }
}

export default oauthcore
